import Highcharts from 'highcharts';

export const figure17 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        marginLeft: 300,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '460px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#ed7d31', '#5b9bd5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: [
          "África septentrional y Asia occidental",
"África subsahariana",
"Oceanía (excluidas Australia y Nueva Zelandia)",
"América del Norte y Europa",
"América Latina y el Caribe",
"Asia oriental y Asia sudoriental",
"Asia central y Asia meridional",
"Australia y Nueva Zelandia",
         ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          format: '{value}',
          formatter: function () {
            return (this.value / 1000000) + "M";
        },
        style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 3000000,
        min: 0,
        tickInterval: 500000,
        gridLineWidth: 2,
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: '2020',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 236452, 213339, 4070, 2758995, 450514, 315733, 574594, 285200 ],
      },
      {
        name: '2000',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data:[ 65576, 143323, 1347, 1631297, 265441, 210697, 351299, 196154 ]
      }
    ]
}